import {
	madnes_add_group,
	madnes_add_img,
	madnes_add_to_group, madnes_get_dimension_wi, madnes_remove_sprite, madnes_set_img_center,
	madnes_set_pos, madnes_set_pos_y, madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
	madnes_add_bitmap_float, madnes_add_bitmap_text,
	madnes_add_text,
	madnes_set_bitmap_float, madnes_set_text
} from "../framework/src/engine/madnes/madnes_text";
import {bet, madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {server_config, multi, picture_convert} from "../framework/src/engine/madnes/madnes_variables";

var info_pos = 1;

var info_pos_count = 3;

var symbolsOffsetX = 40;

var slides = {

	'1': {
		'symbol_Joker': { 'name': 'wintable_symbol_Joker', 'textx': 325, 'texty': 205 },
		'symbol_Seven': { 'name': 'wintable_symbol_Seven', 'textx': 600, 'texty': 205 },
		'symbol_Star': { 'name': 'wintable_symbol_Star', 'textx': 874, 'texty': 205 },

		'symbol_Grape': { 'name': 'wintable_symbol_Grape', 'textx': 325, 'texty': 376 },
		'symbol_Plum': { 'name': 'wintable_symbol_Plum', 'textx': 874, 'texty': 376 },
		'symbol_Melon': { 'name': 'wintable_symbol_Melon', 'textx': 600, 'texty': 376 },

		'symbol_Orange': { 'name': 'wintable_symbol_Orange', 'textx': 325, 'texty': 550 },
		'symbol_Cherry': { 'name': 'wintable_symbol_Cherry', 'textx': 874, 'texty': 550 },
		'symbol_Lemon': { 'name': 'wintable_symbol_Lemon', 'textx': 600, 'texty': 550 },
	}
};

export function j81_infomenu_init()
{
	for(var i = 1; i <= info_pos_count; i++)
	{
		madnes_add_group("settings_group_" + i);
		madnes_set_pos("settings_group_" + i, -9999, -9999);
		madnes_add_img("settings_background_" + i, "settings_background_" + i, 0, 0, 1);
		madnes_add_to_group("settings_group_" + i, "settings_background_" + i);
	}

	/*var style = {
		'font': '40px Arial',
		'align': 'right',
		'fontWeight': 'bold',
		'stroke': '#000',
		'strokeThickness': 3,
		'fill': '#FFF',
	};*/

	for(var	slideIndex in slides) {
		var slide = slides[slideIndex];
		for(var sym in slide) {
			var symbTextName = slide[sym]['name'];
			var textX = slide[sym]['textx'] + symbolsOffsetX;
			var textY = slide[sym]['texty'];

			madnes_add_bitmap_float(symbTextName, "font_wintable", textX, textY, "", 80, 130);
			madnes_set_img_center(symbTextName, 0.5, 0.5);
			madnes_add_to_group("settings_group_" + slideIndex, symbTextName);
 		}
	}

	var infotext = madnes_get_json("infotext");

	for(var i in infotext)
	{
		var x = infotext[i]["position"][0];
		var y = infotext[i]["position"][1];

		var page = infotext[i]["page"];
		var lineHeight0 = infotext[i]["title"]["lineHeight"];
		var lineHeight1 = infotext[i]["lineHeight"];

		var styleTitle = {
			"font": "32px Arial",
			"fill": "#fff600",
			"fontWeight": "",
		};
		var styleBody = {
			"font": "32px Arial",
			"fill": "#ffffff",
			"fontWeight": "",
		};

		if(infotext[i]["fontSize"] && infotext[i]["font"]) {
			styleTitle["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
			styleBody["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
		}

		if(infotext[i]["color"]) {
			styleTitle["fill"] = infotext[i]["color"];
			styleBody["fill"] = infotext[i]["color"];
		}
		if(infotext[i]["title"]["bold"]) {
			styleTitle["fontWeight"] = "bold";
		}

		if(infotext[i]["body"]["bold"]) {
			styleBody["fontWeight"] = "bold";
		}

		if(infotext[i]["title"]["strokeThickness"] && infotext[i]["title"]["strokeThickness"] * 1 > 1) {
			styleTitle["strokeThickness"] = infotext[i]["title"]["strokeThickness"] / multi ;
		}

		if(infotext[i]["title"]["strokeColor"]) {
			styleTitle["strokeColor"] = infotext[i]["title"]["strokeColor"];
		}

		var line0 = 0;
		var line1 = 0;

		for(var j in infotext[i]["title"]["content"])
		{
			var text = infotext[i]["title"]["content"][j];
			var textName = "info_header_" + i + "_"  + j + "_" + line0;
			var groupName = "settings_group_" + ( page * 1 + 1 );

			madnes_add_text(textName, x, y + line0 * lineHeight0, text, styleTitle);
			madnes_add_to_group(groupName, textName);
			line0++;
		}

		for(var j in infotext[i]["body"]["content"])
		{
			var text = infotext[i]["body"]["content"][j];
			var textName = "info_body_" + i + "_"  + j + "_" + line1;
			var groupName = "settings_group_" + ( page * 1 + 1 );

			madnes_add_text(textName, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, styleBody);
			madnes_add_to_group(groupName, textName);
			line1++;
		}
	}

	j81_infomenu_update();
}


function set_info_sums()
{
	var sIdx = picture_convert.indexOf("symbol_Joker");

	var offset = get_bitmap_offset(server_config.logic.symbols[sIdx]['factors'][3] * bet, 130);

	for(var symIndex in server_config.logic.symbols) {
		var factors = server_config.logic.symbols[symIndex]['factors'];
		var symbName = server_config.logic.symbols[symIndex]['name'];
		var val = bet * factors[3];

		madnes_set_bitmap_float("wintable_" + symbName, val, offset > 0 ? 1 : 130);
		madnes_set_pos_y("wintable_" + symbName, slides[1][symbName]['texty'] + offset * -1);
	}
}

export var openinfo = false;

export function j81_infomenu_open()
{
	/*if(!madnes_key_exist('hide_arrows')) {
		madnes_add_group('hide_arrows');
		madnes_add_to_group('hide_arrows', 'btn_arrow_left');
		madnes_add_to_group('hide_arrows', 'btn_arrow_right');
		madnes_set_visible('hide_arrows', false);
	}*/

	/*for(var i = 1; i <= info_pos_count; i++)
	{
		madnes_set_pos("settings_group_" + i, 2500, 0);
	}*/

	madnes_set_visible("settings_group_" + info_pos, true);
	madnes_set_pos("settings_group_" + info_pos, 0, 0);

	openinfo = true;
}

export function j81_infomenu_close()
{
	for(var i = 1; i <= info_pos_count; i++)
	{
		madnes_set_pos("settings_group_" + i, -9999, -9999);
		madnes_set_visible("settings_group_" + i, false);
	}

	openinfo = false;
}

function infomenu_click()
{
	//madnes_audio_play("bet");
	j81_infomenu_update();
}

export function j81_infomenu_update()
{
	setTimeout(function() {
		set_info_sums();
	}, 100);

}

export function j81_infomenu_left()
{
	if(!openinfo) return;
	menu_swipe(1);
}

export function j81_infomenu_right()
{
	if(!openinfo) return;
	menu_swipe(-1);
}

function menu_swipe(dir)
{
	var info_pos2 = info_pos;
	info_pos2 = info_pos2 * 1 + dir * -1;

	if(info_pos2 <= 0)
	{
		info_pos2 = info_pos_count;
	}

	if(info_pos2 > info_pos_count)
	{
		info_pos2 = 1;
	}

	madnes_set_visible("settings_group_" + info_pos, false);
	madnes_set_visible("settings_group_" + info_pos2, true);

	madnes_set_pos("settings_group_" + info_pos2, 0, 0);
	madnes_set_pos("settings_group_" + info_pos, -9999, -9999);

	info_pos = info_pos2;
}
function get_bitmap_offset(text, max_width)
{
	var offs = 0;

	madnes_add_bitmap_text("infotext_tmp", "font_wintable", 0, 0, text, 80);
	madnes_set_text("infotext_tmp", text);

	if(madnes_get_dimension_wi("infotext_tmp") > max_width) {
		offs = 5;
	}

	madnes_remove_sprite("infotext_tmp");

	return offs;
}